import log from '@/utils/datadog/log/log'

// eslint-disable-next-line import/prefer-default-export
export function logError(err: Error) {
  log.error(err.message, err)
  console.error(err)
}
